export const handleIds = obj => {
    if (obj && typeof obj == "object") {
        if (Array.isArray(obj)) {
            obj.forEach(item => {
                handleIds(item);
            });
        } else {
            for (const key in obj) {
                if (obj[key].id) obj[key] = obj[key].id;
                else handleIds(obj[key]);
            }
        }
    }
    return data;
};

export const debounce = (func, wait) => {
    let timeout;

    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
